import React from 'react';
import './Pagination.css';

const Pagination = ({ page, setPage, totalItems, itemsPerPage }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));


  const handleClick = (num) => {
    if (num !== page) setPage(num);
  };

  return (
    <div className="paginationContainer">
      <div className="paginationControls">
        <button
          className="paginationButton"
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
        >
          &lt;
        </button>

        {[...Array(totalPages)].map((_, index) => {
          const pageNum = index + 1;
          return (
            <button
              key={pageNum}
              className={`paginationButton ${pageNum === page ? 'paginationButtonActive' : ''}`}
              onClick={() => handleClick(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}

        <button
          className="paginationButton"
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
